import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { HelmetProvider } from 'react-helmet-async'
import reportWebVitals from './reportWebVitals'
import storeInstance from './store/configureStore'
import { Provider } from 'react-redux'

// Css files
import './index.css'
import 'react-toastify/dist/ReactToastify.css'
import 'assets/scss/app.scss'

const { store } = storeInstance

const ConnectedMainApp = (
  <Provider store={store}>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </Provider>
)

ReactDOM.render(
  ConnectedMainApp,
  document.getElementById('root') as HTMLElement,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
